<template>
  <div class="modal fade" id="productDownload" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content w-500">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <div v-html="getModalmessage()" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning w-150" data-dismiss="modal" @click="productDownloadCSV()">ダウンロード</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/services/productservice'
import moment from 'moment'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    warehouseType: {
      type: String,
      default: 'amazon'
    }
  },
  computed: {
    isWarehouseSalmon () {
      return this.warehouseType === 'salmon'
    }
  },
  methods: {
    async productDownloadCSV () {
      let logParams = {
        name: eventCode.manage_products.report_tab.click_download_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let filename = this.getFileName()
      let params = {
        sellerId: sellerId,
        warehouseType: this.warehouseType
      }
      this.$emit('close')
      await ProductService.postRequestProductDownload(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    getModalmessage () {
      let message = `Amazon倉庫の商品レポート（CSV）をダウンロードします。<br/> よろしければ「ダウンロード」ボタンを押してください。`
      if (this.isWarehouseSalmon) {
        message = `セルモン倉庫の商品レポート（CSV）をダウンロードします。<br/> よろしければ「ダウンロード」ボタンを押してください。`
      }

      return message
    },
    getFileName () {
      let sellerid = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `salmon_amazonProducts_${sellerid}_${reportTime}.csv`
      if (this.isWarehouseSalmon) {
        filename = `salmon_salmonProducts_${sellerid}_${reportTime}.csv`
      }
      return filename
    }
  },
  mounted () {
    $('#productDownload').modal('show')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewModalDownload.vue